import { DataService } from './data.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserService } from './user/user.service';

import { EcomSolutionsService } from '../services/ecomSolutions/ecom-solutions.service';


import { TransactionService } from './transaction/transaction.service';

import { LoginService } from './login/login.service';
import { InvoiceService } from './invoice/invoice.service';
import {FutureBillingService} from './futureBilling/future-billing.service';
import { RegisterService } from './register/register.service';
import { CommonFunctionService } from './Common/common-function.service';
import { ProductService } from './product/product.service';


import { ChangeTempPasswordService } from "./changeTempPassword/change-temp-password.service";
import { ForgotpasswordService } from "./forgotpassword/forgotpassword.service";
import { ResetPasswordService } from "./resetPassword/reset-password.service";
import { CouponsService } from './coupon/coupons.service';
import { AddonBusinessService } from './addonBusiness/addon-business.service';
import { BatchService } from './transaction/batch.service';
import { ReportsService } from './reports/reports.service';
import { SecureVaultService } from './secureVault/secure-vault.service';
import { QuickpayService } from './quickpay/quickpay.service';
import { CreateMerchantService } from './createMerchant/create-merchant.service';
import { SettingsService } from './settings/settings.service';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { RegisterUserService } from './registerUser/register-user.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JwtModule } from "@auth0/angular-jwt";
//import { EmailconfirmationService } from './emailconfirmation/emailconfirmation.service';
import { EmailconfirmationService } from './emailConfirmation/emailconfirmation.service';

@NgModule({
  imports: [CommonModule
   ],
  declarations: [],
  providers: [
    AuthService,
    AuthGuard,
    UserService,
    DataService,
    EcomSolutionsService,
    DataService,
    TransactionService,
    DataService,
    InvoiceService,
    FutureBillingService,
    LoginService,
    RegisterService,
    CommonFunctionService,
    ProductService,
    EmailconfirmationService,
    ResetPasswordService,
    ForgotpasswordService,
    ChangeTempPasswordService,
    CouponsService,
    AddonBusinessService,
    BatchService,
    ReportsService,
    SecureVaultService,
    QuickpayService,
    CreateMerchantService,
    SettingsService,
    RegisterUserService,
    JwtHelperService
  ],
  exports: []
})
export class ServicesModule {}
